export default {
	createdAt: 'Created',
	success: 'Success',
	loading: 'Loading ...',
	yes: 'Yes',
	no: 'No',
	wait: 'Wait ...',
	lastUpdate: 'Last updated. ',
	noUpdates: 'There were no updates',
	choose: 'Select',
	currency: 'Currency',
	all: 'All',
	settings: 'Settings',
	notSet: 'Not specified',
	reset: 'Reset',
	from: 'from',
	to: 'to',
	send: 'Send',
	noItems: 'List is empty',
	areYouSureYouWantToSaveChanges: 'Are you sure you want to save changes?',
	searchPlaceholder: 'Search...',
	metersShortLetter: 'm',
	monthShort: 'mon.',
	max: 'Max',
	months: 'month(-s)',
	select: 'Select...',
	monthsWord: 'months',
	payOnce: 'For the entire period',
	once: 'Once per',
	monthly: 'per month',
	toHome: 'Home',
	download: 'Download',
	somethingWentWrong: 'Oops, something went wrong...',
	somethingWentWrongDescription: 'Please try again. <br/> Or contact support.',
	or: 'Or',
	stepOne: 'Step 1',
	stepTwo: 'Step 2',
	stepThree: 'Step 3',
	from3rdMonth: 'from the 3rd month',
	optional: 'Optional',
	cancel: 'Cancel',
	heading: 'Heading',
	subHeading: 'Subheading',
	normal: 'Normal',
	minValueIs: (value) => `Min value is ${value}`,
	maxValueIs: (value) => `Man value is ${value}`,
	withoutSpaces: 'Should have no spaces',
	of: 'of',
	remains: 'Remains',
	clear: 'Clear',
	areYouSure: 'Are you sure?',
};
